import { render, staticRenderFns } from "./riskStatistics.vue?vue&type=template&id=c03249ee&scoped=true"
import script from "./riskStatistics.vue?vue&type=script&lang=js"
export * from "./riskStatistics.vue?vue&type=script&lang=js"
import style0 from "./riskStatistics.vue?vue&type=style&index=0&id=c03249ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03249ee",
  null
  
)

export default component.exports